import { Toaster, TooltipProvider } from "@colorglo/ui/components";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient } from "./lib/query.ts";
import { routeTree } from "./routeTree.gen.ts";
import { initSentry } from "./sentry.ts";
import "./styles.css";

initSentry("app");

const router = createRouter({ routeTree });
const queryClient = createQueryClient();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        {/*
         * Bottom-centre, not bottom-right: the job card is a right-hand sheet and a toast in
         * that corner lands on top of its save button — which is exactly where someone is
         * looking when the toast fires.
         */}
        <Toaster position="bottom-center" richColors closeButton />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
